import Vue from "vue";
import DashboardPlugin from "./plugins/dashboard-plugin";
import App from "./App.vue";
import i18n from "./i18n";

// router setup
import router from "./routes/router";
import { required } from "vee-validate/dist/rules";

const axios = require("axios");

axios.defaults.baseURL = '';
if (window.location.host == 'torontodvp.posking.ca') {
  axios.defaults.baseURL = 'http://torontodvp.posking.ca/V2';
} else if (window.location.hostname == 'localhost') {
  axios.defaults.baseURL = 'http://localhost';
}
// axios.defaults.baseURL = 'http://localhost:81';
// plugin setup
Vue.use(DashboardPlugin);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: h => h(App),
  router,
  i18n
});

